import { User } from "../../types";
import { admin, forecaster } from "./axios";
import { getAxiosInstance, UserGroup } from "./constants";
import { GetTrendsParams } from "./trends";

export type GetColorAnalysisParams = GetTrendsParams & {
  primary_colour?: string;
};

export const getColorAnalysisData = async (
  params: GetColorAnalysisParams,
  user: User | null
) => {
  if (user === null) {
    throw new Error("User is not available");
  }

  const { group } = user!;
  if (!group) {
    console.error("Group Not Found");
    return;
  }

  try {
    const axiosInstance = getAxiosInstance(user.group as UserGroup);
    if (axiosInstance) {
      const response = await axiosInstance.get(`/trends/colour-analysis`, {
        params,
      });
      return response?.data;
    } else {
      console.error("Group not found");
    }
  } catch (error) {
    console.error("Error fetching trends:", error);
    throw error;
  }
};
